const GlobalNavbar = () => {
  return (
    <div className='app-navbar flex-shrink-0'>
     
    </div>
  )
}

export { GlobalNavbar }
